'use client'
import React from 'react';
import NextImage from 'next/image';
import { Skeleton } from '@/app/components/ui/skeleton';
import ZoomableImage from './ZoomableImage';
import { Flex, Text } from '@radix-ui/themes';

interface Props {
  loading: boolean;
  images: any[];
  currentIndex: number;
}

const MainImagePreview = ({ loading, images, currentIndex }: Props) => {
  if (loading)
    return <Skeleton className={`h-full w-full`} />

  if (images.length === 0)
    return (
      <Flex className="w-full" align="center" justify="center">
        <Text className="select-none">This lot contains no images.</Text>
      </Flex>
    )

  return (
    <ZoomableImage
      src={images[currentIndex].preview}
    />
  )
}

export default MainImagePreview 
